const Helpers = require('utils/Helpers');
const catalogConstants = require('constants/Search');
const urlUtils = require('utils/Url');
const localeUtils = require('utils/LanguageLocale');

const CatalogSortOption = catalogConstants.SEARCH_SORT_OPTIONS;

function getRegions(content) {
    const regions = content && content.regions ? content.regions : null;
    const top = regions && regions.content ? regions.content : null;
    const bottom = regions && regions.bottom ? regions.bottom : null;

    return {
        top,
        bottom
    };
}

function addCategoryOptions(displayOptions, category, isCollapseNth) {
    if (category) {
        displayOptions.catalogId = category.categoryId;
    }

    const categoryDisplayOptions = { displayOptions };

    if (isCollapseNth && category) {
        categoryDisplayOptions.currentCategoryLevel = category.level;
    }

    return categoryDisplayOptions;
}

function addBrandOptions(displayOptions, brandInfo, isCollapseNth) {
    if (brandInfo) {
        displayOptions.catalogId = brandInfo.node || brandInfo.nodeStr || brandInfo.catalogId;
    }

    const categoryDisplayOptions = { displayOptions };

    if (brandInfo && isCollapseNth) {
        categoryDisplayOptions.currentCategoryLevel = brandInfo.level;
    }

    return categoryDisplayOptions;
}

function addSearchOptions(displayOptions, searchInfo) {
    displayOptions.catalogId = searchInfo?.catalogId;

    return { displayOptions };
}

/**
 * Gets the catalog info from a categories array using the
 * search parameters passed in the options.
 *
 * @param   {array} categories - A categories object
 * @param   {object} options - An object of options in the following format:
 *          { parameter: 'isSelected', value: true }
 */

function getCatalogInfoFromCategories(categories, options) {
    if (!categories || categories[options.parameter] === options.value) {
        return categories;
    }

    let result, property;

    for (property in categories) {
        if (Object.prototype.hasOwnProperty.call(categories, property) &&
            (Helpers.isObject(categories[property]) || Array.isArray(categories[property]))) {

            result = getCatalogInfoFromCategories(categories[property], options);

            if (result) {
                return result;
            }
        }
    }

    return result;
}

function getCatalogInfoByURL(url, categories) {
    // Removing /ca/en or /ca/fr to normalize this logic
    const urlSections = url.replace(urlUtils.isSEOForCanadaRegExp, '').split('/');

    const isAllCategories =
        urlSections[urlSections.length - 1] === catalogConstants.ALL_CATEGORIES_SEO_NAME;

    const isSearch =
        urlSections[1] === catalogConstants.KEYWORD_SEARCH;

    let catalogInfo;

    if (isAllCategories) {
        catalogInfo = { catalogId: catalogConstants.ALL_CATEGORIES_SEO_NAME };
    } else if (isSearch) {
        const queryParams = urlUtils.getParams(window.location.search, ['keyword']);
        catalogInfo = { catalogId: queryParams.keyword[0] };
    } else {
        catalogInfo = getCatalogInfoFromCategories(categories, {
            parameter: 'targetUrl',
            value: url
        });
    }

    return catalogInfo;
}

// We prepend targetUrls with /ca/en or /ca/fr so they will be properly matched for Canada URLs
// on getCatalogInfoByURL, when calling getCatalogInfoFromCategories
function updateTargetUrl(object) {
    object.targetUrl = urlUtils.getLink(object.targetUrl);
}

function visitCategories(categories, fn) {
    if (Array.isArray(categories)) {
        categories.forEach(category => {
            fn(category);
            visitCategories(category.subCategories, fn);
        });
    }
}

function handleSEOForCanada(data) {
    if (Sephora.isSEOForCanadaEnabled && localeUtils.isCanada()) {
        updateTargetUrl(data);
        visitCategories(data.categories, updateTargetUrl);
    }
    return data;
}

function getPropertyNameFromCategory(category, catalogKeyName) {
    return category[catalogKeyName] || category.categoryId;
}

function getNavDataAtValue(level) {
    switch (level) {
        case 0:
            return 'category_level';
        case 1:
            return 'top_level';
        default:
            return 'nth_level';
    }
}

function removeRefinements(refinements, options) {
    if (!options || !options.parameter || !options.value) {
        return refinements;
    }

    return refinements.filter(
        refinement => refinement[options.parameter] !== options.value
    );
}

function getRefinementsFromQueryParams(queryParams) {
    let refinementsIds = [];

    const refinementsInQueryParams = queryParams['ref']?.slice();

    if (refinementsInQueryParams && refinementsInQueryParams.length) {
        if (refinementsInQueryParams.length === 1) {
            refinementsIds = refinementsInQueryParams[0].split(',');
        } else {
            refinementsIds = refinementsInQueryParams;
        }
    }

    return refinementsIds;
}

function normalizeRefinementValue(val) {
    // some refinement values are stored like filter[name]=value
    // sometimes we just want to compare filter[name]
    return val.replace(/\=.*/, '');
}

module.exports = {
    getRegions,
    addCategoryOptions,
    addBrandOptions,
    addSearchOptions,
    CatalogSortOption,
    getCatalogInfoFromCategories,
    getCatalogInfoByURL,
    getPropertyNameFromCategory,
    getNavDataAtValue,
    handleSEOForCanada,
    removeRefinements,
    getRefinementsFromQueryParams,
    normalizeRefinementValue
};
